module.exports = __webpack_public_path__ + "img/monitor-swiper-2.24a105bd.png";